import React from 'react'
import { Card, Flex, Text, Textarea } from '@workwhile/ui'
import JsonView from '@uiw/react-json-view'
import { useHttpServicesContextValue } from '../context/HttpServicesProvider'

type ResponsePanelProps = {
  response: NonNullable<
    ReturnType<typeof useHttpServicesContextValue>['state']['response']
  >
}

export const ResponsePanel = ({ response }: ResponsePanelProps) => {
  const isSuccess = response.statusCode >= 200 && response.statusCode < 300
  const { body } = response

  return (
    <Card shadowless p={3} mt={4}>
      <Flex gap={3} alignItems="baseline">
        <Text fontWeight="bold" color={isSuccess ? 'success' : 'error'}>
          {response.statusCode}
        </Text>
        <Text fontSize={1} color="lightText">
          {Math.round(response.elapsedMs)} ms
        </Text>
        <Text fontSize={1}>{response.url}</Text>
      </Flex>

      <Text fontWeight="bold" mt={3}>
        Headers
      </Text>
      <JsonView value={response.headers} collapsed displayDataTypes={false} />

      <Text fontWeight="bold" mt={3}>
        Body
      </Text>
      {body !== null && typeof body === 'object' ? (
        <JsonView value={body} collapsed={2} displayDataTypes={false} />
      ) : (
        <Textarea readOnly value={String(body)} />
      )}
    </Card>
  )
}
